// extracted by mini-css-extract-plugin
export default {"like":"_1S5Id","not-clickable":"_1We60","notClickable":"_1We60","likebutton":"_1Cn-3","likes":"_3j0S-"};